export * from './type-juridiction.model';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/type-juridiction/index.ts